export default "__VITE_ASSET__yKTlbb9r__"